// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"276":"ErrorSnack","436":"Wallet","496":"MyProfileView","625":"Networks","838":"PlayGame"}[chunkId] || chunkId) + "." + {"202":"23cb8f61","276":"b2ec74cd","436":"37a6a57a","496":"5d27a3c1","625":"fcd9b95f","838":"735a89bc"}[chunkId] + ".js";
};